import React from 'react';
function Spacer() {
    return(
        <div style={{marginLeft: 'auto', marginRight: 'auto'}}/>
    );
}

export default Spacer;